import * as React from "react";

/*
	THE MENU BUTTON - THREE DOTS THAT BECOME A CROSS WHEN THE PANEL OPENS.
	BOTH SETS OF SHAPES ARE ALWAYS PRESENT SO CSS CAN ANIMATE BETWEEN THEM.
*/
function MenuMorph({ theme = "red" }) {
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g className='Dots'>
        <circle className='Dot Left' cx='4' cy='12' r='2' stroke={theme} />
        <circle className='Dot Middle' cx='12' cy='12' r='2' stroke={theme} />
        <circle className='Dot Right' cx='20' cy='12' r='2' stroke={theme} />
      </g>
      <g className='Cross'>
        <line
          className='Stroke'
          x1='5'
          y1='5'
          x2='19'
          y2='19'
          stroke={theme}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <line
          className='Stroke'
          x1='19'
          y1='5'
          x2='5'
          y2='19'
          stroke={theme}
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </g>
    </svg>
  );
}

export default MenuMorph;
